/* jscs:disable maximumLineLength */
export default {
    config: {
        shareUrl: {
            default: {
                baseUrl: 'https://yandex.ru/chat',
                restUrl: '#/forward',
                params: {
                    text: {
                        options: ['title', 'url'],
                        separator: '\n'
                    }
                }
            }
        }
    },

    i18n: {
        az: 'Яндекс.Мессенджер',
        be: 'Яндекс.Мессенджер',
        en: 'Yandex.Messenger',
        hy: 'Yandex.Messenger',
        ka: 'Yandex.Messenger',
        kk: 'Яндекс.Мессенджер',
        ro: 'Yandex.Messenger',
        ru: 'Яндекс.Мессенджер',
        tr: 'Yandex.Messenger',
        tt: 'Яндекс.Мессенджер',
        uk: 'Yandex.Messenger',
        uz: 'Yandex.Messenger'
    },

    color: '#03CECE'
};
